module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "open": true
    }
  }, [_c('div', {
    staticClass: "game-container",
    class: {
      show: _vm.show
    }
  }, [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.startGame && _vm.verbalShow),
      expression: "!startGame && verbalShow"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "20141399!important"
    },
    attrs: {
      "type": _vm.type
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1280px",
      "height": "1000px",
      "margin": "0 auto",
      "overflow": "visible"
    }
  }, [_c('iframe', {
    ref: "gameContainer",
    staticClass: "game-iframe",
    attrs: {
      "name": "openGames",
      "src": _vm.gameUrl,
      "scrolling": "no"
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f3ba6370!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/trainCronSave.vue
// module id = 1034
// module chunks = 2